/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useRef, useState} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {StepperComponent} from '../../../../../../../../../_metronic/assets/ts/components'
import {useToast} from '../../../../../../../components/Toats'
import {KTSVG} from '../../../../../../../../../_metronic/helpers'
import {LoadingSpan} from '../../../../../../../components/Loadings/loadingSpan'
import {deleteEmailUC} from '../../../../../../../../services/emailRedirectUCService'

type Props = {
  id: string
  data: any
  show: boolean
  handleClose: () => void
}

const modalsRoot = document.getElementById('root-modals') || document.body

const ModalDeleteEmail = ({show, handleClose, id, data}: Props) => {
  const {toggleToast} = useToast()
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [loading, setLoading] = useState(false)

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const closed = () => {
    handleClose()
  }

  const deleteEmailSubmit = async () => {
    try {
      setLoading(true)

      await deleteEmailUC(id)
      toggleToast('Sucesso ao deletar o e-mail. ', 'success')
    } catch (error) {
      console.log(error)
      toggleToast('Erro ao deletar o e-mail. ', 'error')
    } finally {
      setLoading(false)
      closed()
    }
  }

  const submit = () => {
    deleteEmailSubmit()
  }

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-500px'
      show={show}
      onHide={closed}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>
            Deletar e-mail {' - '}
            {data && data.email ? data.email : 'Não identificado'}
          </span>
        </h3>

        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
          id='kt_modal_create_app_stepper'
        >
          <div className='flex-row-fluid py-lg-0'>
            <div style={{marginBottom: '3rem'}}>
              <h3 className='card-title align-items-start flex-column'>
                <span className='text-muted mt-1 fw-semibold fs-5'>
                  Deseja deletar esse email permanentemente?
                </span>
              </h3>
            </div>

            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <button
                type='button'
                className='btn btn-lg btn-light'
                disabled={loading}
                onClick={() => {
                  closed()
                }}
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr063.svg'
                  className='svg-icon-3 ms-2 me-0'
                />
                <span style={{marginLeft: '0.5rem'}}>Cancelar</span>
              </button>

              <button
                type='button'
                className='btn btn-lg btn-danger'
                disabled={loading}
                onClick={submit}
              >
                Deletar
                {loading ? (
                  <LoadingSpan style={{marginLeft: '0.5rem'}} />
                ) : (
                  <KTSVG
                    path='/media/icons/duotune/arrows/arr064.svg'
                    className='svg-icon-3 ms-2 me-0'
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalDeleteEmail}
